import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Datenschutz from '../views/Datenschutz.vue'
import Impressum from '../views/Impressum.vue'
import Partner from '../views/Partner.vue'
import Artist from '../components/Artist.vue'

import '../assets/css/index.css';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: "/artist/:id",
        name: 'Artist',
        component: Artist,
        meta: {
          showArtist: true
        }
      }
    ]
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: Datenschutz
  },
  {
    path: '/impressum',
    name: 'Impressum',
    component: Impressum
  },
  {
    path: '/partner',
    name: 'Partner',
    component: Partner
  },
  {
    path: '*',
    name: '404',
    component: Home
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;